import { FC } from 'react'
import { Text } from '@blueprintjs/core'
import { Link } from '@inertiajs/react'
import ctl from '@netlify/classnames-template-literals'
import { Button } from 'client/components/Button/Button'
import { AppHead } from 'client/components/Layout/components/AppHead/AppHead'
import { ResponsiveBlock } from 'client/components/ResponsiveBlock/ResponsiveBlock'

type TProps = {
  status: number
}

const ErrorPage: FC<TProps> = ({ status }) => {
  const title = {
    503: '503: Service Unavailable',
    500: '500: Server Error',
    404: '404: Page is not found',
    403: '403: Forbidden',
  }[status]

  const description = {
    503: 'Sorry, we are doing some maintenance. Please check back soon.',
    500: 'Whoops, something went wrong on our servers.',
    404: '',
    403: 'Sorry, you are forbidden from accessing this page.',
  }[status]

  return (
    <article className="flex w-full flex-1 flex-col">
      <AppHead />
      <ResponsiveBlock>
        <div className="flex w-full flex-col items-center justify-center gap-6" style={{ height: '37.5rem' }}>
          <Text tagName="h1" className="font-title---32px text-center uppercase text-palette-white">
            {title}
          </Text>
          <Text tagName="span" className="font-primary-regular---15pt text-text-black text-center">
            {description}
          </Text>
          <div className="flex w-full flex-col items-center justify-center gap-8 md:flex-row md:gap-12 xl:gap-20">
            <Link
              href="/"
              className={ctl(`
                  bg-surface-tertiary flex h-12 w-full items-center
                  justify-center px-8 hover:no-underline focus:outline-hidden sm:w-72`)}
            >
              <Button>Return to main page</Button>
            </Link>
          </div>
        </div>
      </ResponsiveBlock>
    </article>
  )
}

export default ErrorPage
